

export default function ThermalCal() {
    
    return (
        <div>
            敬請留意....
        </div>
    )

}